<div class="animated fadeIn rounded">
    <div class="card">
        <div class="card-header">
            <i class="fa fa-gift"></i> Crear Giftcard
            <div class="card-header-actions btn-group" dropdown placement="bottom left">
            </div>
        </div>

        <div class="card-body">
            <pos-stepper #cdkStepper linear="true" (selectionChange)="changeStep($event)">
                <cdk-step label="Cliente" [stepControl]="formCustomer">
                    <customer-step [formCustomer]="formCustomer" (getCustomerStepInfo)="getCustomerStepInfo($event)"
                        [onlyCustomer]="true" [customer]="customer" #customerStepComponent>
                    </customer-step>
                </cdk-step>
                <cdk-step label="Giftcards" [stepControl]="formCart">
                    <gifcard-cart-step [customer]="customer" (getTableFormExternal)="getCartForm($event)"
                        (getOrder)="getOrder($event)"
                        (changeGiftcardValue)="changeGiftcardValue($event)"></gifcard-cart-step>
                </cdk-step>
                <cdk-step label="Pagos" [stepControl]="formPayments">
                    <invoice-details-step [invoice]="invoice" (doPayment)="getPayments($event)" id="gifcardInvoice"
                        #paymentsStep></invoice-details-step>
                </cdk-step>
                <cdk-step label="Guardar">
                    <pay-invoice-step [paymentRequest]="paymentRequest" [order]="simulatedOrder"
                        (doPay)="pay($event)"></pay-invoice-step>
                </cdk-step>
            </pos-stepper>
        </div>
    </div>
</div>